import { render, staticRenderFns } from "./PartnersSection.vue?vue&type=template&id=1b186b0f&scoped=true"
import script from "./PartnersSection.vue?vue&type=script&lang=js"
export * from "./PartnersSection.vue?vue&type=script&lang=js"
import style0 from "./PartnersSection.vue?vue&type=style&index=0&id=1b186b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b186b0f",
  null
  
)

export default component.exports